import { render, staticRenderFns } from "./landings.vue?vue&type=template&id=788b3a59"
import script from "./landings.vue?vue&type=script&lang=js"
export * from "./landings.vue?vue&type=script&lang=js"
import style0 from "./layout.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports